import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective, SmartSearchState } from 'mbs-ui-kit';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import Computer from 'mbs-ui-shared@models/Computer';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { map } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-computer-name-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchComputerNameTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchComputerNameTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;
  computerFacade = inject(ComputersFacade);

  public tag = SmartSearchTemplateName.ComputerName;

  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();
    this.i18nPipe = i18nPipe;

    this.isSequenceMultiple = false;
  }

  public items = (state: SmartSearchState) => {
    return this.computerFacade.getData$(true).pipe(
      map((values) =>
        values
          .filter((value) => value.name.includes(state.leftCaretClearValue))
          .map((value) => ({
            value: value.hid,
            searchText: Computer.getComputerName(value),
            translation: null
          }))
      )
    );
  };
}
